import { Options } from '../../Options'
import { ChartGridConstants } from './ChartGrid.constants'

export const chartGridOptions = Options.asRecord(
  Options.createOption({
    key: 'showGridlines',
    inputKind: 'boolean',
    label: 'Show gridlines',
    description: 'Render gridlines at this axis tick positions.',
    category: 'Axis',
  }),
)

export type ChartGridOptions = Options.TypeOf<typeof chartGridOptions>

export const defaultShowXGridlines = ChartGridConstants.defaultShowXGridlines
export const defaultShowYGridlines = ChartGridConstants.defaultShowYGridlines
